import { gql, NetworkStatus, useQuery } from "@apollo/client";
import { shiftStreamClient } from "./client";

export const GET_ROLES = gql`
  query getRoles($clientIds: [Int!]) {
    roles(clientIds: $clientIds) {
      id
      name
    }
  }
`;

export const useRoles = ({ clientIds }: { clientIds: number[] | null }) => {
  const { data, loading, networkStatus } = useQuery(GET_ROLES, {
    client: shiftStreamClient,
    variables: { clientIds },
    fetchPolicy: "cache-and-network",
    notifyOnNetworkStatusChange: true,
    onError: error => {
      throw error;
    }
  });

  const resolvedData = data;

  return {
    loading: loading || networkStatus === NetworkStatus.refetch,
    roles: resolvedData?.roles || []
  };
};
